import InfoBox from 'google-maps-infobox'

export const infoBoxes = []
export const setInfoBox = newInfoBox => infoBoxes.push(newInfoBox)
export const clearInfoBoxes = () => infoBoxes.splice(0, infoBoxes.length)

export const createInfoBox = opts => {
  return new InfoBox(opts)
}

export const closeInfoBox = infoBox => {
  infoBox.close()
}

// https://htmlpreview.github.io/?https://github.com/googlemaps/v3-utility-library/blob/master/infobox/docs/reference.html#InfoBoxOptions
// https://stackoverflow.com/questions/12102598/trigger-event-with-infowindow-or-infobox-on-click-google-map-api-v3



// WEBPACK FOOTER //
// ./app/utils/infoBox.js